<template>
  <generic-modal
    size
    :title="$t('pet-customer relationship')"
    icon="paw"
    image="/images/icons/customer_pet_relationship.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("customer") }}</label>
            <div class="ui search" ref="customer_search">
              <div class="ui icon input">
                <input
                  class="prompt"
                  type="text"
                  :placeholder="$t('search')"
                  name="customer"
                />
                <i class="search icon"></i>
              </div>
              <div class="results"></div>
            </div>
            <div class="ui fluid card" v-if="customer_.customer_id">
              <div class="content">
                <div class="header">{{ customer_.name }}</div>
                <div class="description">
                  {{ $t("customer since") }}
                  {{ customer_.create_date | fromNow }}
                </div>
              </div>
              <div
                class="ui basic bottom attached button"
                v-on:click="clean_customer"
              >
                <i class="erase icon"></i>
                {{ $t("clean") }}
              </div>
            </div>
          </div>
          <div class="field">
            <label for>{{ $t("pet") }}</label>
            <div class="ui search" ref="pet_search">
              <div class="ui icon input">
                <input
                  class="prompt"
                  type="text"
                  :placeholder="$t('search')"
                  name="pet"
                />
                <i class="search icon"></i>
              </div>
              <div class="results"></div>
            </div>
            <div class="ui fluid card" v-if="pet_.pet_id">
              <div class="content">
                <div class="header">{{ pet_.name }}</div>
                <div class="description">
                  {{ $t("customer since") }}
                  {{ pet_.create_date | fromNow }}
                </div>
              </div>
              <div
                class="ui basic bottom attached button"
                v-on:click="clean_customer"
              >
                <i class="erase icon"></i>
                {{ $t("clean") }}
              </div>
            </div>
          </div>
        </div>
        <div class="field">
          <label for="">{{ $t("relationship") }}</label>
          <input type="text" name="relation" v-model="relation" />
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { local_api, error_toast } from "@/utils";
import filters from "@/filters";
import GenericModal from "@/components/GenericModal";

export default {
  components: {
    "generic-modal": GenericModal
  },
  filters: filters,
  computed: {
    form() {
      let vm = this;
      return window.jQuery(vm.$refs.form).form({
        fields: {
          customer: ["empty"],
          pet: ["empty"]
        }
      });
    }
  },
  props: { pet: Object, customer: Object, relationship: Object },
  data() {
    return {
      // customer_id: "",
      // pet_id: "",
      relation: "",
      customer_: {},
      pet_: {}
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = vm.form.form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/pet_customer_relationship/do-save", {
            i: vm.relationship ? vm.relationship.uuid : undefined,
            p: vm.pet.pet_id,
            c: vm.customer.customer_id,
            r: vm.relationship
          })
            .then((relationship) => {
              vm.$emit("succedded", relationship);
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    clean_customer() {
      this.customer_ = {};
    }
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.customer_search).search({
      apiSettings: {
        action: "search customer",
        beforeXHR: function(xhr) {
          let token = vm.$session.get("token");
          if (token) {
            xhr.setRequestHeader("x-access-token", token);
          }
          return xhr;
        },
        onResponse: function(response) {
          if (!response.success) error_toast(response.error);
          else {
            var _response = {
              results: []
            };
            response.data.map((r) => {
              _response.results.push({
                title: r.name,
                description: r.description,
                id: r.uuid,
                customer: r
              });
            });
            return _response;
          }
        }
      },
      onSelect(result) {
        vm.customer_ = result.customer;
      }
    });

    window.jQuery(vm.$refs.pet_search).search({
      apiSettings: {
        action: "search pet",
        beforeXHR: function(xhr) {
          let token = vm.$session.get("token");
          if (token) {
            xhr.setRequestHeader("x-access-token", token);
          }
          return xhr;
        },
        onResponse: function(response) {
          if (!response.success) error_toast(response.error);
          else {
            var _response = {
              results: []
            };
            response.data.map((r) => {
              _response.results.push({
                title: r.name,
                description: r.description,
                id: r.uuid,
                pet: r
              });
            });
            return _response;
          }
        }
      },
      onSelect(result) {
        vm.pet_ = result.pet;
      }
    });

    if (vm.$props.customer) this.customer_ = vm.$props.customer;
    if (vm.$props.pet) this.pet_ = vm.$props.pet;
  },
  watch: {},
  updated: function() {
    this.$nextTick(function() {});
  }
};
</script>
